<template>
    <section class="border border-dark mb-4">
        <!-- header box -->
        <div class="row formbox-header mx-0 px-0 align-items-center" :class="{active: appendExtra}">
            <div class="col pl-0 pr-2 d-flex align-items-center">
                <h4><md-icon :icon="icon" /> {{ title }}</h4>
				<p><slot name="append-title" /></p>
            </div>

            <div class="col-auto px-0 text-right pr-1 align-items-center" v-if="appendExtra">
				<slot name="append-title-end"></slot>
            </div>
        </div>

        <!-- content box -->
        <slot></slot>
    </section>
</template>

<script>
// import MainLayout from '../layout/MainLayout.vue'
// import api from '../../../api.js'

export default {
    props: {
        title: {
            type: String,
            required: false,
            default: "",
        },
        icon: {
            type: String,
            required: false,
            default: "",
        },
		appendExtra : {
			type: Boolean,
			required: false,
			default: false
		}
    },
    components: {},
    data() {
        return {};
    },
    methods: {},
    mounted() {},
};
</script>

<style scoped>
.formbox-header h4 {
	margin-bottom: 0;
}

.formbox-header p {
	margin-bottom: 0;
}

.formbox-header.active {
	width: 95%;
}

section {
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 1em 1em 0.5em;
    position: relative;
}
.icon {
    position: absolute;
    right: 0;
    left: 0;
    top: -25px;
    margin: auto;
    background: #fff;
}
@media (min-width: 500px) {
    .formbox-header {
        font-size: 1.5rem;
        position: absolute;
        top: -16px;
        left: 10px;
        background: #fff;
        padding: 0 10px;
    }
}
</style>
